module.exports = __webpack_public_path__ + "static/media/dondonki-logo.fda8c0e3.png";